import CellValue from '@app/shared/components/cell-value/CellValue';
import { ComponentProps, FC } from 'react';

interface SummaryRowProps {
  label: string;
  columnsCount: number;
  cellValueProps: ComponentProps<typeof CellValue>;
  dataTestId: string;
  isStrong?: boolean;
  isSectionStart?: boolean;
}

const SummaryRow: FC<SummaryRowProps> = ({
  label,
  columnsCount,
  cellValueProps,
  dataTestId,
  isStrong = false,
  isSectionStart = false,
}) => {
  const separatorClass = 'table-primary__cell--vertical-separator';
  const sectionStartClass = isSectionStart ? ' table-primary__cell--section-start-separator' : '';
  const strongClass = isStrong ? ' table-primary__cell--strong' : '';

  return (
    <tr data-testid={`${dataTestId}-row`}>
      <th className={`${separatorClass}${sectionStartClass}${strongClass}`}>{label}</th>
      <td className={`${separatorClass}${sectionStartClass}`} />
      <td
        colSpan={columnsCount - 2}
        className={`${separatorClass}${sectionStartClass}${strongClass}`}>
        <CellValue {...cellValueProps} />
      </td>
    </tr>
  );
};

export default SummaryRow;
